import React from "react";

const PricesPage = () => (
  <div />
)

export default PricesPage;
